import { useState } from 'react';
import constate from 'constate';
const AuthenticationContext = () => {
    const [authToken, setAuthToken] = useState();
    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const state = { authToken, isAuthenticating };
    const actions = { setAuthToken, setIsAuthenticating };
    const context = [state, actions];
    return context;
};
export const useAuthentication = constate(AuthenticationContext);
//# sourceMappingURL=useAuthentication.js.map